import { ButtonConfig } from '@zipari/shared-ds-util-button';

export interface ImpersonationBarConfig {
  label: string;
  prop: string;
  button: ButtonConfig;
}

export interface ImpersonationBarArgs {
  condition: unknown;
  context: unknown;
  config: ImpersonationBarConfig;

  endImpersonation?: () => void;
}
